<template>
  <div class="table-wrapper">
    <table class="mx-2">
      <caption>
        Mis pagos
        <v-btn 
          class="bg-blue"
          @click="openDialogPayment = true"
        >
          <v-icon>mdi-cash</v-icon>
          Pagar hospedaje
        </v-btn>
      </caption>
      <thead>
        <tr>
          <th>
            Empresa
          </th>
          <th>
            Titular
          </th>
          <th>
            Desde
          </th>
          <th>
            Hasta
          </th>
          <th>
            Teléfono
          </th>
          <th>
            Medio de pago
          </th>
          <th>
            Valor
          </th>
          <th>
            Referencia
          </th>
          <th>
            Estado
          </th>
        </tr>
      </thead>
      <tr
        v-for="payment in myPayments"
        :key="payment.idLodgingPayment"
      >
        <td>
          {{ payment.company.company }}
        </td>
        <td>
          {{ payment.user.name }} {{ payment.user.surNames }}
        </td>
        <td>
          {{ formatDate(payment.startDate) }}
        </td>
        <td>
          {{ formatDate(payment.endDate) }}
        </td>
        <td>
          {{ payment.company.phone }}
        </td>
        <td>
          {{ payment.paymentType }}
        </td>
        <td>
          {{ enPesos(payment.cost) }}
        </td>
        <td>
          {{ payment.paymentReference }}
        </td>
        <td>
          {{ estadoEnEspanol(payment.paymentStatus) }}
        </td>
      </tr>
    </table>
    <div class="pagination-container" v-if="totalPages > 1">
      <v-pagination
        v-model="page"
        :length="totalPages"
        :total-visible="5"
        density="comfortable"
        active-color="primary"
        @update:model-value="loadPayments"
      />
    </div>
    <v-dialog v-model="openDialogPayment">
      <v-card>
        <v-card-title>
          Pagar un mes de hospedaje
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="selectedIdCompany"
            :items="listMyCompanys"
            item-title="company"
            item-value="idCompany"
            label="Elige una empresa"
            outlined
            dense
          />
          <!-- El monto se ve ANTES de abrir la pasarela: hasta ahora el
               boton cobraba sin decir cuanto. -->
          <div class="resumen-pago">
            <span>Un mes de visibilidad</span>
            <strong>{{ precioMesEnPesos }} COP</strong>
          </div>

          <v-btn 
            color="green" 
            :loading="pagando"
            :disabled="!selectedIdCompany"
            @click="payWithWompi()"
          >
            Pagar {{ precioMesEnPesos }}
          </v-btn>
        </v-card-text>
      </v-card> 
    </v-dialog>

    <!-- Antes esto era un alert() del navegador: bloquea la pagina y una vez
         aceptado no queda forma de releer que paso -->
    <v-snackbar
      :model-value="!!avisoPago"
      :timeout="colorAviso === 'success' ? 6000 : -1"
      :color="colorAviso"
      location="top"
      @update:model-value="avisoPago = ''"
    >
      {{ avisoPago }}
      <template #actions>
        <v-btn
          variant="text"
          size="small"
          @click="avisoPago = ''"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import apisPayments from '@/apis/apisPayments';
import apisCompanys from '@/apis/apisCompanys';
import apisPAYS from '@/apis/apisPAYS';
import apisUsers from '@/apis/apisUsers';
import { precioMesHospedaje, enPesos as enPesosConfig, PRECIO_MES_RESPALDO } from '@/utils/configuracion';
import { mensajeDeError } from '@/utils/errores';
import { confirmarPagoWompi } from '@/utils/pagoWompi';
/*
  list status reference:
    APPROVED: Transacción aprobada
    DECLINED: Transacción rechazada
    VOIDED: Transacción anulada (sólo aplica pra transacciones con tarjeta)
    ERROR: Error interno del método de pago respectivo
*/

export default {
  name: 'MyPaymentsView',
  data(){
    return {
      openDialogPayment: false,
      pagando: false,
      listMyCompanys: [],
      myPayments: [],
      selectedIdCompany: null,
      page: 1,
      totalPages: 0,
      avisoPago: '',
      colorAviso: 'error',
      // Lo administra Settings. Arranca en el respaldo para no mostrar un
      // precio vacio mientras llega la respuesta.
      precioMes: PRECIO_MES_RESPALDO
    }
  },
  computed: {
    precioMesEnPesos() {
      return enPesosConfig(this.precioMes)
    }
  },
  created() {
    precioMesHospedaje().then(precio => {
      this.precioMes = precio
    })

    apisUsers.isValid()
      .then(isValid => {
        if (!isValid){
          this.$router.push('/')
        }else{
          this.loadPayments(1)
          apisCompanys.getMyCompanys()
            .then(CompanyResponse => {
              this.listMyCompanys = CompanyResponse;
            })
        }
      })


  },
  methods: {
    loadPayments(page) {
      apisPayments.getMyPayments(page - 1)
        .then(response => {
          this.myPayments = response.content;
          this.totalPages = response.totalPages;
          this.page = response.pageNumber + 1;
        })
        .catch(error => {
          console.error("Error fetching payments:", error);
        });
    },
    formatDate(dateArray) {
      if (!dateArray) return "";
      // dateArray = [YYYY, MM, DD, HH, mm, ss]
      const [year, month, day] = dateArray;
      // Crea objeto Date (OJO: mes en JS empieza desde 0)
      const date = new Date(year, month - 1, day);

      // Formato "YYYY-MM-DD HH:mm:ss"
      return date.toLocaleString("es-CO", { 
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    },
    /** 20000 -> "$ 20.000". Antes salia el numero crudo */
    enPesos(valor) {
      const numero = Number(valor)
      if (valor === null || valor === undefined || isNaN(numero)) {
        return '-'
      }
      return `$ ${numero.toLocaleString('es-CO')}`
    },
    /**
     * Wompi devuelve el estado en ingles y en mayusculas. Se traduce solo
     * para mostrar: el valor que se guarda sigue siendo el del proveedor,
     * porque es contra el que compara companyIsEnabled.
     */
    estadoEnEspanol(estado) {
      const estados = {
        APPROVED: 'Aprobado',
        PENDING: 'Pendiente',
        DECLINED: 'Rechazado',
        VOIDED: 'Anulado',
        ERROR: 'Con error'
      }
      return estados[estado] || estado || '-'
    },
    /**
     * Espera a que Vuetify suelte el scroll de la pagina.
     *
     * Mientras un v-dialog esta abierto, Vuetify le pone a <html> la clase
     * v-overlay-scroll-blocked (position: fixed). El widget de Wompi es un
     * bloque alto que se recorre con el scroll de la pagina, asi que abierto
     * encima del dialogo quedaba congelado: en celular no se alcanzaba la
     * parte de abajo para pagar.
     */
    esperarScrollLibre() {
      return new Promise(resolve => {
        const inicio = Date.now()
        const revisar = () => {
          const bloqueado = document.documentElement.classList.contains('v-overlay-scroll-blocked')
          // Con tope: si algo mas lo deja bloqueado, mejor abrir igual que no abrir
          if (!bloqueado || Date.now() - inicio > 1000) {
            resolve()
          } else {
            setTimeout(revisar, 50)
          }
        }
        revisar()
      })
    },
    payWithWompi() {
      ///numero de prueba 3991111111 
      const reference = this.selectedIdCompany;
      this.pagando = true

      apisPAYS.payOneMonth(reference)
        .then(async data => {
          // El dialogo se cierra ANTES de abrir Wompi: ver esperarScrollLibre
          this.openDialogPayment = false
          await this.esperarScrollLibre()

          const checkout = new window.WidgetCheckout({
            currency: data.currency,
            amountInCents: data.amountInCents, // Wompi requiere centavos
            reference: data.reference,
            publicKey: data.publicKey, // ⚠️ tu llave pública de pruebas
            signature: {integrity:data.signature}
          })

          // Antes, si salia APPROVED, se hacia router.push a esta misma vista,
          // que no hace nada: ni aviso ni tabla actualizada
          checkout.open(async (result) => {
            const { mensaje, color } = await confirmarPagoWompi(result)
            this.colorAviso = color
            this.avisoPago = mensaje
            this.loadPayments(1)
          });

        })
        .catch(error => {
          this.colorAviso = 'error'
          this.avisoPago = mensajeDeError(error, 'No se pudo iniciar el pago')
        })
        .finally(() => {
          this.pagando = false
        })
    }
  }
}
</script>
<style scoped>
.resumen-pago {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: #f2f5f9;
  font-size: 0.9rem;
  color: #475467;
}

.card{
  padding: 20px;
}
.table-wrapper {
  padding: 20px;
  overflow-x: auto;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

caption {
  caption-side: top; /* O usa 'bottom' si lo prefieres debajo */
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: left;
  padding: 12px 16px;
  background-color: #f0f2f5;
  border-bottom: 2px solid #ddd;
}
thead {
  background-color: #f0f2f5;
}

th, td {
  padding: 12px 16px;
  text-align: left;
}

th {
  font-weight: bold;
  font-size: 14px;
  color: #333;
  border-bottom: 2px solid #ddd;
}

td {
  border-top: 1px solid #eee;
  font-size: 14px;
  color: #444;
}

/* Fila hover */
tbody tr:hover {
  background-color: #f9f9f9;
  transition: background-color 0.2s;
}

.pagination-container {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}
</style>
